import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { ClusterModalType, HelpIndex } from '../../../models/enums';

@Component({
    standalone: false,
    selector: 'res-build-clusters-modal',
    templateUrl: './build-clusters-modal.component.html',
    styleUrls: ['./build-clusters-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BuildClustersModalComponent extends BaseModalComponent implements OnInit {

    modalAutomationId: string;
    modalTitle: string;
    secondaryButtonLabel = 'Cancel';
    primaryButtonLabel: string;
    modalClass = 'build-clusters-modal';
    topLevelCheckboxLabel = ' Top Level Clusters';
    isBuildSubclustersMode = false;
    subclusterLevelsChecked = false;
    noOfLevels: { value: number };
    helpIndex = HelpIndex.build_rebuild_clusters_dlg;

    constructor(private modalService: BsModalService, private modalRef: BsModalRef,) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        if (this.modalData) {
            this.modalTitle = this.modalData.clusterModalType;
            this.primaryButtonLabel = this.modalData.clusterModalType;
            this.setModalInfoByModalType(this.modalData.clusterModalType);
            this.noOfLevels = this.modalData.subclusterLevels ? { value: this.modalData.subclusterLevels } : { value: 2 };
        }
    }

    setModalInfoByModalType(modalType: ClusterModalType) {
        switch (modalType) {
            case ClusterModalType.Build:
                this.modalAutomationId = 'build-clusters';
                this.topLevelCheckboxLabel = 'Build' + this.topLevelCheckboxLabel;
                break;
            case ClusterModalType.Rebuild:
                this.modalAutomationId = 'rebuild-clusters';
                this.topLevelCheckboxLabel = 'Rebuild' + this.topLevelCheckboxLabel;
                break;
            case ClusterModalType.Generate:
                this.modalAutomationId = 'generate-cluster-report';
                this.helpIndex = HelpIndex.generate_cluster_report_dlg;
                this.topLevelCheckboxLabel = 'Include' + this.topLevelCheckboxLabel;
                break;
            case ClusterModalType.Subclusters:
                this.modalAutomationId = 'build-subclusters';
                this.isBuildSubclustersMode = true;
                break;
        }
    }

    submit(): void {
        const levels = this.isBuildSubclustersMode ? this.noOfLevels.value : (this.subclusterLevelsChecked && this.noOfLevels.value <= 10 ? this.noOfLevels.value : 0);
        this.closeModal(true, { subclusterLevels: levels });
    }

}
